import type {
  SimulationInputsStatus,
  SimulationScenarioRunStatus,
} from '@/gateways/impl/SimulationGateway';

export const SCENARIO_RUNNABLE_INPUTS_STATUSES = new Set<SimulationInputsStatus>([
  'UPLOADED',
  'READY',
]);

export function canCreateScenarioForInputsStatus(
  status: SimulationInputsStatus | undefined,
): status is SimulationInputsStatus {
  return status !== undefined && SCENARIO_RUNNABLE_INPUTS_STATUSES.has(status);
}

export function disabledScenarioReason(status: SimulationInputsStatus | undefined): string {
  switch (status) {
    case 'DRAFT':
      return 'Upload inputs to enable scenarios.';
    case 'INGESTING':
      return 'Inputs are still being ingested. Try again in a moment.';
    case 'FAILED':
      return 'Inputs upload failed. Re-upload to enable scenarios.';
    default:
      return 'Scenarios are not available for this simulation yet.';
  }
}

export const TERMINAL_INPUTS_STATUSES = new Set<SimulationInputsStatus>([
  'UPLOADED',
  'READY',
  'FAILED',
]);

export const TERMINAL_RUN_STATUSES = new Set<SimulationScenarioRunStatus>(['COMPLETED', 'FAILED']);

export function isTerminalRunStatus(status: SimulationScenarioRunStatus | undefined): boolean {
  return status !== undefined && TERMINAL_RUN_STATUSES.has(status);
}
